const relationId = value => value && typeof value === 'object' ? value.id ?? null : value;

export function projectTypePayload(data) {
  const payload = {...data};
  for (const field of ['project_number_type', 'initial_status', 'warehouse']) {
    if (Object.prototype.hasOwnProperty.call(data, field)) payload[field] = relationId(data[field]);
  }
  payload.shared_cost_center = relationId(Object.prototype.hasOwnProperty.call(data, 'shared_cost_center_id') ? data.shared_cost_center_id : data.shared_cost_center) || null;
  payload.shared_profit_center = relationId(Object.prototype.hasOwnProperty.call(data, 'shared_profit_center_id') ? data.shared_profit_center_id : data.shared_profit_center) || null;
  return payload;
}
